<template>
  <div class="p2p-detail-1r">

    <div class="p2p-detail-meta">
      <div class="row p2p-meta-routec">
        <router-link
          :to="{
                        name: 'routeinfo',
                        params: {
                            id: detail.route.routeid,
                        }
                    }"
          class="routec"
        >{{ detail.route.routec }}
        </router-link>
        <div class="fare">$ {{ detail.stops[0].fare }}</div>
      </div>

      <div class="destinc">
        往: {{ destinc }}
      </div>
    </div>


    <table class="p2p-stop-table">
      <tbody>
      <tr
        v-for="(stop, index) in detail.stops"
        :key="index"
        class="p2p-detail-1r-row"
        @click="stopDetail(stop)"
      >
        <td class="stop-icon">
          <div></div>
        </td>
        <td class="stop-bar"></td>
        <td
          :class="{'highlighted-stop': (index === 0 || index === detail.stops.length - 1)}"
          class="stopc"
        >{{ stop.stopc }}
        </td>
      </tr>
      </tbody>

    </table>

  </div>
</template>

<script>
import {mapMutations} from 'vuex';

export default {
  name: "PointToPointDetail1R",
  props: ['detail'],
  computed: {
    destinc() {
      if (this.detail.stops[0].routedir === 1) {
        return this.detail.route.destinc;
      } else {
        return this.detail.route.startc;
      }
    },
  },
  methods: {
    ...mapMutations('googleMap', ['openOnlyInfoWindow', 'updateBound']),

    stopDetail(stopItem) {

      this.openOnlyInfoWindow(stopItem);
      this.updateBound([
        {
          ...stopItem,
          position: {
            lat: stopItem.lat,
            lng: stopItem.lng,
          },
        },
      ]);

    },
  },
}
</script>

<style scoped>
.p2p-detail-1r {
  margin-top: 8px;
  margin-bottom: 8px;
}

div.p2p-detail-1r-row {
  border-bottom: 1px solid grey;
  padding: 8px;
}

.highlighted-stop {
  font-size: 120%;
  font-weight: bold;
}

.p2p-detail-meta {
  margin-bottom: 8px;
}

.p2p-meta-routec {
  display: flex;
  justify-content: space-between;
}

.routec {
  font-size: 120%;
  font-weight: bold;
}

.stopc {
  padding: 8px;
}
</style>
<style>
.p2p-stop-table {
  border-collapse: collapse;
}

.stop-icon div {
  height: 10px;
  width: 10px;
  border: 2px solid orange;
  border-radius: 100%;
  position: relative;
  left: 7px;
  background: white;
  z-index: 1001;
}

td.stop-bar {
  width: 2px;
  background: orange;
  position: relative;

}

tr:first-child .stop-bar::before {
  background: rgb(240, 240, 240);
  width: 5px;
  height: 50%;
  /* border: 1px solid green; */
  content: '';
  position: absolute;
  top: 0;
  left: -50%;
}

tr:last-child .stop-bar::before {
  background: rgb(240, 240, 240);
  width: 5px;
  height: 50%;
  /* border: 1px solid green; */
  content: '';
  position: absolute;
  /*bottom: -50%*/
  left: -50%;
}
</style>
